import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, json } from '../../lib/api';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { SearchInput } from '../../components/SearchInput';
import { ErrorBanner } from '../../components/ErrorBanner';
import { AddModal } from '../../components/AddModal';
import { useScope } from '../../context/ScopeContext';

export function ServicesPage() {
  const scope = useScope();
  const qc = useQueryClient();
  const [search, setSearch] = useState('');
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [categoryCode, setCategoryCode] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const categories = useQuery({ queryKey: ['categories'], queryFn: () => api<any[]>('/catalog/categories') });
  const q = useQuery({ queryKey: ['services', scope.companyId, search], queryFn: () => api<any>(`/catalog/services?page=1&pageSize=100&companyId=${scope.companyId}&search=${encodeURIComponent(search)}`), enabled: Boolean(scope.companyId) });
  const createCategory = useMutation({ mutationFn: () => api('/catalog/categories', { method: 'POST', ...json({ companyId: scope.companyId, code: categoryCode, name: categoryName, active: true }) }), onSuccess: () => { setCategoryCode(''); setCategoryName(''); qc.invalidateQueries({ queryKey: ['categories'] }); } });
  const create = useMutation({ mutationFn: () => api('/catalog/services', { method: 'POST', ...json({ companyId: scope.companyId, code, name, categoryId, active: true }) }), onSuccess: () => { setCode(''); setName(''); setCategoryId(''); qc.invalidateQueries({ queryKey: ['services'] }); } });
  const scopedCategories = (categories.data ?? []).filter(x => x.companyId === scope.companyId);

  return <section>
    <PageHeader title="Service Catalog" subtitle="Stable service IDs with effective-dated historical pricing" actions={<>
      <AddModal title="Add service" buttonLabel="+ Add service" submitLabel="Create service" disabled={!scope.companyId} error={create.error} onSubmit={() => create.mutateAsync()}>
        <label>Code<input value={code} onChange={e => setCode(e.target.value)} required autoFocus /></label>
        <label>Name<input value={name} onChange={e => setName(e.target.value)} required /></label>
        <label>Category<select value={categoryId} onChange={e => setCategoryId(e.target.value)} required><option value="">Category…</option>{scopedCategories.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}</select></label>
      </AddModal>
      <AddModal title="Add service category" buttonLabel="+ Add category" submitLabel="Create category" disabled={!scope.companyId} error={createCategory.error} onSubmit={() => createCategory.mutateAsync()}>
        <label>Code<input value={categoryCode} onChange={e => setCategoryCode(e.target.value)} required autoFocus /></label>
        <label>Name<input value={categoryName} onChange={e => setCategoryName(e.target.value)} required /></label>
      </AddModal>
    </>} />
    <div className="toolbar"><SearchInput value={search} onChange={setSearch} /></div>
    <ErrorBanner error={q.error || create.error || createCategory.error} />
    <div className="card"><DataTable rows={q.data?.items ?? []} columns={[
      { key: 'code', header: 'Code', render: (r: any) => <Link to={`/catalog/services/${r.id}`}>{r.code}</Link> },
      { key: 'name', header: 'Service', render: (r: any) => r.name },
      { key: 'category', header: 'Category', render: (r: any) => r.category?.name ?? r.categoryId },
      { key: 'prices', header: 'Price versions', render: (r: any) => r.prices?.length ?? 0 },
      { key: 'status', header: 'Status', render: (r: any) => r.active ? 'Active' : 'Inactive' },
    ]} /></div>
  </section>;
}
